"use strict";var e=require("../Coerce/enumeration.cjs").enumeration(["CONSOLE","DESKTOP","DONGLE","FRIDGE","MOBILE","SET_TOP_BOX","TABLET","TV","UNKNOWN"]);exports.DeviceType=e;
//# sourceMappingURL=DeviceType.cjs.map
